import { BlocksIconSearch } from 'blocks-nextjs/blocks-web-components/components/icon/icons/search';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSearch = createComponent({ react: React, tagName: 'cat-icon-search', elementClass: BlocksIconSearch });
